const KNOWN_PREFIXES = ['cms', 'cms-atlas', 'cms-legacy'];

/**
 * The base href the app is served under, derived from the first path segment so
 * one build runs under /cms/, /cms-atlas/ or /cms-legacy/ on the same host.
 * An unrecognised segment falls back to /cms/ so a stray path cannot point asset
 * loading at a prefix the ALB does not route to this container.
 */
export function cmsBaseHref(pathname: string): string {
  const segment = pathname.split('/').filter(Boolean)[0] || '';
  const prefix = KNOWN_PREFIXES.includes(segment) ? segment : 'cms';
  return `/${prefix}/`;
}

/** The OAuth redirect for the path the app is currently served under. */
export function cmsAuthRedirect(origin: string, pathname: string): string {
  return `${origin}${cmsBaseHref(pathname)}`;
}
